var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    fillRule: "evenodd",
    d: "M167.442342,59.7703571 L159.5,54.5532143 L151.557658,59.7703571 C151.065181,60.0935714 150.427215,60.0735714 149.955169,59.7210714 C149.483124,59.3682143 149.27634,58.7557143 149.435567,58.1832143 L151.92226,49.2482143 L144.499521,42.8871429 C144.061998,42.5121429 143.89185,41.9060714 144.069396,41.3535714 C144.246941,40.8014286 144.7366,40.4128571 145.307987,40.3714286 L154.211329,39.7217857 L158.218432,30.8346429 C158.447761,30.3260714 158.948693,30 159.5,30 C160.051307,30 160.552239,30.3260714 160.781568,30.8346429 L164.788671,39.7217857 L173.692013,40.3714286 C174.2634,40.4128571 174.753059,40.8014286 174.930604,41.3535714 C175.10815,41.9060714 174.938002,42.5121429 174.500479,42.8871429 L167.07774,49.2482143 L169.564433,58.1832143 C169.72366,58.7557143 169.516876,59.3682143 169.044831,59.7210714 C168.796831,59.9064286 168.503035,60 168.208183,60 C167.942217,60 167.675899,59.9235714 167.442342,59.7703571 Z",
    transform: "translate(-144 -30)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGrey);
export default __webpack_public_path__ + "static/media/star-grey.208d92b65af9d721997e363209cf8155.svg";
export { ForwardRef as ReactComponent };